<template>
    <b-modal class="contactFormModal" size="lg" @hidden="onHidden"
             :hide-footer="true" :no-close-on-backdrop="true"
             v-model="showContactFormModal" title="Get Special Quote">

        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <b>From: </b> <span>{{from}}</span>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <b>To: </b> <span>{{to}}</span>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <b>Date: </b> <span>{{date}}</span>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <b>Time: </b> <span>{{time}}</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 form-group">
                <input type="text" class="form-control" v-model="email" placeholder="Email" />
                <div class="error" v-show="formSent && !this.email">Please enter your email to receive quotation.</div>
                <div class="error" v-show="formSent && !this.isEmailValid">Email is not in a correct format.</div>
            </div>
            <div class="col-md-6 form-group">
                <input type="text" class="form-control" v-model="phone" placeholder="Phone" />
            </div>
        </div>
        <div class="row">
            <div class="col form-group">
                <textarea class="form-control" v-model="message" placeholder="Any extra requirements or comments" rows="4"></textarea>
            </div>
        </div>
        <div class="row mt-40 text-center">
            <div class="col">
                <button class="btn btn-primary" @click="sendQuoteRequest">Get Quote</button>
            </div>
        </div>
    </b-modal>
</template>
<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import ApiService from "../services/serviceApi"
    import { email } from 'vuelidate/lib/validators';

    export default {
        name: "ContactForm",
        data() {
            return {
                email: '',
                phone: '',
                message: '',
                formSent: false,
                sending: false,
                showContactFormModal: false
            }
        },
        components: { bModal },
        created: function() {
            this.$on('showw', function () { console.log('showw event');} );
        },
        watch: {
            showContactForm: function (newValue, oldValue) {
                this.showContactFormModal = newValue;
            }
        },
        events: {
            showw: function(){
                console.log('showw');
            }
        },
        methods: {
            showModal: function () {
                this.showContactFormModal = true;
            },
            onHidden: function () {
                this.$store.commit("setShowContactForm", false);
            },
            sendQuoteRequest: function () {
                this.formSent = true;
                if (!this.email || !email(this.email)) return;

                if (this.sending) return;
                this.sending = true;
                var bookingInfo = this.$store.state.bookingInfo.general;
                var quotationModel =
                    {
                        apiKey: this.$store.state.configuration.apiKey,
                        email: this.email,
                        phone: this.phone,
                        message: this.message,
                        from: bookingInfo.pickupAddress.text,
                        to: bookingInfo.dropOffAddress.text,
                        hours: bookingInfo.durationInHours,
                        pickupAt: bookingInfo.pickupDate + " " + bookingInfo.pickupTime,
                    };
                ApiService.sendQuotationForm(quotationModel).then((response) => {
                    this.sending = false;
                    this.onHidden();
                }).catch(error => {
                    this.sending = false;
                });
            }
        },
        computed: {
            isEmailValid: function () { return email(this.email); },
            showContactForm: function () { return this.$store.state.otherForms.showCustomQuoteForm; },
            from: function () { return this.$store.state.bookingInfo.general.pickupAddress.text; }, 
            to: function () { return this.$store.state.bookingInfo.general.dropOffAddress.text; }, 
            date: function () { return this.$store.state.bookingInfo.general.pickupDate; },
            time: function () { return this.$store.state.bookingInfo.general.pickupTime; }
        }
    }
</script>
<style>
    .contactFormModal .modal {
        background: rgba(0, 0, 0, 0.62);
    }
    .contactFormModal .modal-title {
        display: inline-block;
    }
</style>
